
import axios from "axios";
export default {
  name: "PricingSection",
  data() {
    return {
      pricingPlans: [
        {
          title: "usage",
          price: " 0,1",
          subtitle: "pro Abfrage",
          button: "coming soon!",
          active: false,
        },
        {
          title: "basic",
          price: " 10",
          subtitle: "monatlich",
          active: true,
          button: "Jetzt auspobieren",
        },
        {
          title: "premium",
          price: " 25",
          subtitle: "monatlich",
          button: "coming soon!",
          active: false,
        },
        // fügen Sie hier weitere Pläne hinzu
      ],
    };
  },
  methods: {
    CheckIfUserIsLoggedIn(plan: any) {
      // Führen Sie den Axios-Befehl aus, um zu überprüfen, ob der Benutzer angemeldet ist
      axios.get("https://okr-chekcer.de/check-login-state").then((response) => {
        // Hier können Sie die Stripe-Zahlungsseite öffnen oder eine Weiterleitung durchführen
        console.log(response.data.loggedIn);
        if (response.data.loggedIn) {
          this.redirectToStripePayment(plan);
        } else {
          window.location.href = "https://okr-chekcer.de/login";
        }
      });
    },

    redirectToStripePayment(plan: any) {
      // Führen Sie den Axios-Befehl aus, um zur Stripe-Zahlungsseite zu gelangen

      axios
        .post("https://payment.keravonos.com/api/v1/stripe", {
          product_name: "OKRChecker-" + plan.title,
          unit_amount: plan.price * 100,
          mode: "subscription",
          recuring_interval: "month",
          recuring_interval_count: 1,
          success_url: "https://okr-chekcer.de/success",
          cancel_url: "https://okr-chekcer.de/cancel",
          currency: "eur",
        })
        .then((response) => {
          // Hier können Sie die Stripe-Zahlungsseite öffnen oder eine Weiterleitung durchführen
          console.log(response);

          const paymentUrl = response.data.url;
          window.location.href = paymentUrl;
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
